const colors = {
  white: '#FFF',
  white02: '#F9F9F9',
  black: '#000',
  gray: 'gray',
  darkBlue: '#364150',
  darkBlue02: '#2C4F9E',
  lightBlue: '#00ADEE',
  lightBlue02: '#0090C5',
  lightBlue03: '#1e90c5',
  lightBlue04: '#b4d5df',
  lightBlue05: '#53AAEA',
  lightBlue06: '#E8F0F3',
  lightBlue07: '#0C4BBC',
  lightBlue08: '#d4e7fa',
  lightBlue09: '#93c4f5',
  lightBlue10: '#58a4ef',
  lightBlue11: '#91c3f4',
  lightBlue12: '#659BE0',
  lightBlue13: '#659BE0',
  lightBlue14: '#e5f3ff',
  lightBlue15: '#00AEEF',
  lightBlue16: '#3699FF',
  lightBlue17: '#68A8F5',
  lightBlue18: '#a7adba',
  lightGray: '#eee',
  lightGray02: '#ccc',
  lightGray03: 'rgb(236, 247, 251)',
  lightGray04: '#F6F6F6',
  lightGray05: '#f7f7f7',
  lightGray06: '#DADADA',
  lightGray07: '#E6F0F3',
  lightGray08: '#DBDBDB',
  lightGray09: '#E7E7E7',
  lightGray10: '#f3f3f3',
  lightGray11: '#ECECEC',
  lightGray12: '#E3E3E3',
  lightGray13: '#b7b2b2',
  lightGray14: '#989898',
  lightGray15: '#f5f5f5',
  lightGray16: '#d1d1d1',
  lightGray17: '#E2E2E2',
  lightGray18: '#F0F0F0',
  lightGray19: '#F1F4F9',
  darkGray01: '#4D4D4D',
  darkGray02: '#757272',
  darkGray03: '#827e7e',
  darkGray04: '#4a4a4a',
  darkGray05: '#848181',
  darkGray06: '#5e615e',
  darkGray07: '#808080',
  darkGray08: '#7f7f7f',
  darkGray09: '#3c4043',
  darkGray10: '#444746',
  darkGray11: '#3D505A',
  darkGray12: '#7d7d7d',
  darkGray13: '#3D4F59',
  greenNormal: 'green',
  green01: '#26d02d',
  green02: '#61BB46',
  green03: '#29CF6A',
  green04: '#82BA50',
  green05: '#60bb47',
  green06: '#0BB31F',
  green07: '#62BA46',
  green08: '#57B551',
  green09: '#58B553',
  lightGreen: '#E6F0F3',
  lightGreen02: '#DAE7EB',
  link: '#0000EE',
  red: 'red',
  red02: '#e87a7a',
  red03: '#E15C4B',
  red04: '#FF0000',
  red05: '#E91E63',
  red06: '#E01E5A',
  red07: '#e84335',
  red08: '#F369693D',
  red09: '#F36969',
  red10: '#f50057',
  red11: '#e65556',
  blue: 'blue',
  yellow01: '#FFC700',
  yellow02: '#FFFBEF',
  yellow03: '#ECE5CF',
  yellow04: '#E4AA46',
  yellow05: 'rgba(232, 181, 80, 0.25)',
  dark01: 'rgba(0, 0, 0, 0.87)',
  dark02: 'rgba(0, 0, 0, 0.70)',
  dark03: 'rgba(0, 0, 0, 0.12)',
  dark04: 'rgba(0, 0, 0, 0.24)',
  lightOrange: '#f8761f',
  lightPurple: '#A294F9',
  colorTags: [
    '#61bd4f',
    '#f2d600',
    '#ff9f1a',
    '#eb5a46',
    '#c377e0',
    '#0079bf',
    '#00c2e0',
    '#51e898',
    '#ff78cb',
    '#344563',
  ],
};

export default colors;
